﻿$.fn.dxCtrlContentEmailEnvoiNormal = function custom_dxCtrlContentEmailEnvoiNormal(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentemailenvoinormal dx-ctrl");
        this.createInstance(new cdxCtrlContentEmailEnvoiNormal(this, option));
    }
    return this;
}

window.cdxCtrlContentEmailEnvoiNormal = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var jauge = null
    //var $DivResume = null
    var $DivEntete = null
    var $DivDest = null
    this.isDirty = function (value) {
        if (typeof value != 'undefined') this.dxContentEmailBase.isDirty(value)
        return this.dxContentEmailBase.isDirty(value)
    }

    this.dxContentEmailBase = null
    var $DivTaille = null
    function mConstruit() {
        container.empty()
        container.css({ "height": "100%", "width": "100%" })

        if (typeof option.jauge == 'undefined') { jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance") }
        else { jauge = option.jauge }
        jauge.mShow();

        $DivEntete = $("<div style='width:100%;padding:0px;box-sizing:border-box;'/>").appendTo(container)
        if (parametre.isMobile) $DivEntete.css("padding", "0 10px")
        if (option.data.id_type_classement != 10 && option.data.error != null && option.data.error.length > 0) {
            $("<div style='margin:2px;'/>").appendTo($DivEntete).dxCtrlWarningForm({
                type: "error",
                icon: "fas fa-triangle-exclamation",
                contentTemplate: function (contentElement) {
                    //$("<span class='dxwarningformtext'>Nous avons rencontré l'erreur «<i>" + option.data.error + "</i>» durant la dernière tentative d'envoi.</span>").appendTo(contentElement)
                    var $Table = $("<table/>").appendTo(contentElement)
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='width:100%'/>").appendTo($Tr)
                    $("<div class='dxwarningformtext'>Nous avons rencontré l'erreur «<i>" + option.data.error + "</i>» durant la dernière tentative d'envoi.</div>").appendTo($Td)
                    $("<div class='dxwarningformtext'>Prochaine tentative d'envoi <b>" + option.data.date_envoi.toDateIlya() + "</b>.</div>").appendTo($Td)
                    var $Td = $("<td style='width:1%'/>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlButton({
                        text: "Renvoyer",
                        hint: "En renvoyant votre email immédiatement, votre message sera renvoyé via les serveur smtp de " + parametre.nom,
                        onClick: function (e) {
                            option.data.date_envoi = parametre.dateNow
                            option.data.id_type_smtp_forcer = 4 //on force sur le smtp2go quotidien
                            option.data.id_type_classement = 9
                            option.data.nb_error = 0
                            option.data.error = null
                            option.bddCtrl.getObjet(option.data).mSave()
                            page.mRemovePopup(option.data)
                        }
                    })
                    if (option.data.tracking == "1") {
                        var $Td = $("<td style='width:1%'/>").appendTo($Tr)
                        $("<div/>").appendTo($Td).dxCtrlButton({
                            text: "Renvoyer sans tracking",
                            hint: "Ce mail a été envoyé avec un suivi de tracking. En renvoyant votre email immédiatement, votre message sera renvoyé via les serveur smtp de " + parametre.nom + " sans tracking.",
                            onClick: function (e) {
                                option.data.date_envoi = parametre.dateNow
                                option.data.id_type_smtp_forcer = 4 //on force sur le smtp2go quotidien
                                option.data.id_type_classement = 9
                                option.data.nb_error = 0
                                option.data.error = null
                                option.data.tracking = "0"
                                option.bddCtrl.getObjet(option.data).mSave()
                                page.mRemovePopup(option.data)
                            }
                        })
                    }
                }
            }).dxCtrlWarningForm("instance")
        } else if (option.data.id_type_classement == 9 && diffdate(parametre.dateNow, option.data.date_envoi, "s") > 5) {
            var dxWarningFormTempo = $("<div style='margin:2px;'/>").appendTo($DivEntete).dxCtrlWarningForm({
                type: "warning",
                icon: "fas fa-information",
                html: function () { return "<span class='dxwarningformtext'><b>Votre message est en cours d'envoi</b>:<br/>" + option.data.statut_txt + "</span>"; },
                contentTemplate: function (contentElement) {
                    mConstruitContainerEnvoiTempo(contentElement, true, function () { page.mRemovePopup(option.data) })
                }
            }).dxCtrlWarningForm("instance")
        } else if (option.data.id_type_classement == 8) {
            $("<div style='margin:2px;'/>").appendTo($DivEntete).dxCtrlWarningForm({
                type: "warning",
                icon: "fas fa-information",
                contentTemplate: function (contentElement) {
                    var $Table = $("<table/>").appendTo(contentElement)
                    var $Tr = $("<tr/>").appendTo($Table)
                    //var $TdMessage = $("<td style='width:100%;'></td>").appendTo($Tr)
                    if ((new Date(option.data.date_envoi)).addMinutes(-5) > parametre.dateNow && option.data.ignore_attente_compte_email == "1") {
                        //on une date d'envoi programmé 
                        var $Td = $("<td style='width:100%;'>L'envoi de votre message est programmé " + option.data.date_envoi.toDateIlya() + " (" + option.data.date_envoi.toFrenchDateTime() + ")</td>").appendTo($Tr)
                    } else {
                        var $Td = $("<td style='width:100%;'>Votre message est en attente d'envoi </td>").appendTo($Tr)
                        $A = $("<a href='javascript:void(0)'>conformément à la configuration de votre compte email</a>").appendTo($Td)
                        $A.on("click", function (e) {
                            e.stopPropagation()
                            option.bddCtrl.getObjet("compte_email", option.data.id_compte_email).objetMetier.mShowPopup({
                                id_utilisateur: option.bddCtrl.utiCourant.id_utilisateur,
                                idAccordion: 2
                            })
                        })
                    }
                    var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlButton({
                        text: "Annuler envoi",
                        hint: "Annuler l'envoi et mettre l'email dans les brouillons",
                        onClick: function (e) {
                            page.mRemovePopup(option.data)
                            option.data.date_envoi = null
                            option.data.id_type_classement = 7
                            option.bddCtrl.getObjet(option.data).mSave(function (data) {
                                option.bddCtrl.getObjet(option.data).mShowPopup()
                            })
                        }
                    })
                    var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlButton({
                        text: "envoyer immédiatement",
                        hint: "Ignorer le paramètrage du compte email et envoyer immédiatement l'email",
                        onClick: function (e) {
                            page.mRemovePopup(option.data)
                            option.data.ignore_attente_compte_email = "1"
                            option.data.id_type_classement = 9
                            option.data.date_envoi = parametre.dateNow
                            option.bddCtrl.getObjet(option.data).mSave()
                        }
                    })

                    function mDecompte() {
                        if ($Table.closest("body").length == 0 || option.data.date_envoi == null) return
                        var newDataEnvoi = option.bddCtrl.getObjet("com_email_envoi", option.data.id_com_email_envoi).data
                        if (!newDataEnvoi) page.mRemovePopup(option.data)
                        if (newDataEnvoi.id_type_classement != option.data.id_type_classement) {
                            page.mRemovePopup(option.data)
                        } else {
                            window.setTimeout(function () { mDecompte() }, 3000)
                        }
                        //if ($TdMessage.closest("body").length == 0 || option.data.date_envoi == null) return
                        //let totalSeconds = 500;
                        //let minutes = Math.floor(totalSeconds / 60);
                        //let seconds = totalSeconds % 60;
                        //var dataCompteEmail = option.bddCtrl.mGetArray("compte_email").filter(function (o) { return o.id_compte_email == option.data.id_compte_email })[0]
                        //if (dataCompteEmail.envoi_temporisation_mn != null && option.data.ignore_attente_compte_email == "0") {
                        //    $TdMessage.html("L'envoi de vos emails est temporisé.<br/>L'email sera envoyé dans " + (new Date()).decompte(option.data.date_envoi))
                        //} else if ((new Date(option.data.date_envoi)).addMinutes(-5) > parametre.dateNow && option.data.ignore_attente_compte_email == "1") {
                        //    $TdMessage.html("Une date d'envoi dans le futur a été programmée.<br/>L'email sera envoyée dans " + (new Date()).decompte(option.data.date_envoi) + " (" + option.data.date_envoi.toFrenchDateTime() + ").")
                        //} else {
                        //    $TdMessage.html("L'envoi de vos emails est temporisé.<br/>L'email sera envoyé dans " + (new Date()).decompte(option.data.date_envoi))
                        //}
                        //if (diffdate(parametre.dateNow, option.data.date_envoi, "s") < 3) {
                        //    page.mRemovePopup(option.data)
                        //    //funcDepasse()
                        //} else { window.setTimeout(function () { mDecompte() }, 3000) }
                    }
                    mDecompte()
                    //var $Table = $("<table/>").appendTo(contentElement)
                    //var $Tr = $("<tr/>").appendTo($Table)
                    //if ((new Date(option.data.date_envoi)).addMinutes(-5) > parametre.dateNow && option.data.ignore_attente_compte_email == "1") {
                    //    //on aucune date dans le 
                    //    var $Td = $("<td style='width:100%;'>L'envoi de votre message est programmé " + option.data.date_envoi.toDateIlya() + " (" + option.data.date_envoi.toFrenchDateTime() + ")</td>").appendTo($Tr)
                    //} else {
                    //    var $Td = $("<td style='width:100%;'>Votre message est en attente d'envoi </td>").appendTo($Tr)
                    //    $A = $("<a href='javascript:void(0)'>conformément à la configuration de votre compte email</a>").appendTo($Td)
                    //    $A.on("click", function (e) {
                    //        e.stopPropagation()
                    //        option.bddCtrl.getObjet("compte_email", option.data.id_compte_email).objetMetier.mShowPopup({
                    //            id_utilisateur: option.bddCtrl.utiCourant.id_utilisateur,
                    //            idAccordion: 2
                    //        })
                    //    })
                    //}
                    //var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                    //$("<div/>").appendTo($Td).dxCtrlButton({
                    //    text: "Annuler l'envoi",
                    //    hint: "Annuler l'envoi et mettre l'email dans les brouillons",
                    //    onClick: function (e) {
                    //        page.mRemovePopup(option.data)
                    //        option.data.date_envoi = null
                    //        option.data.id_type_classement = 7
                    //        option.bddCtrl.getObjet(option.data).mSave(function () {
                    //            option.bddCtrl.getObjet(option.data).mShowPopup()
                    //            mNotify("L'envoi de votre message a été annulé et replacé dans les brouillons", "success", 6000)
                    //        })

                    //    }
                    //})
                    //var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                    //$("<div/>").appendTo($Td).dxCtrlButton({
                    //    text: "envoyer immédiatement",
                    //    hint: "Ignorer le paramètrage du compte email et envoyer immédiatement l'email",
                    //    onClick: function (e) {
                    //        page.mRemovePopup(option.data)
                    //        option.data.ignore_attente_compte_email = "1"
                    //        option.data.id_type_classement = 9
                    //        option.data.date_envoi = parametre.dateNow
                    //        option.bddCtrl.getObjet(option.data).mSave()
                    //    }
                    //})
                }
            }).dxCtrlWarningForm("instance")
        }

        $DivDest = $("<div/>").appendTo($DivEntete)
        mRempliDest()

        var $DivDoc = $("<div style='padding:2px;width:100%;'/>").appendTo(container)
        var funcResize = resizeObserver.mAdd($DivEntete, function () {
            $DivDoc.css("height", "calc(100% - " + (($DivEntete.is(":visible")) ? ($DivEntete.innerHeight() + 5) : 0) + "px)");
        })()
        var opt = {
            bddCtrl: option.bddCtrl,
            onChangeObjet: function (objet) {
                option.data.objet = objet
            },
            onDemandeUrl: function (funcFin) {
                Me.dxContentEmailBase.mSaveAuto(function () {
                    option.bddCtrl.mAjaxCall({ command: "getemailurl", id_com_email_envoi: option.data.id_com_email_envoi }, function (data) {
                        funcFin(data.url)
                    })
                })
            },
            readOnly: (option.data.date_envoi != null),
            data: option.data,
            saveAuto: (option.data.id_type_classement == 7),
            onSave: function () {
                if (typeof option.onChange != 'undefined') option.onChange()
            },
            onContentReady: function () {
                mFinLoad()
            }
        }
        if (option.data.date_envoi == null) {
            opt.onSlide = function (isSlideDown) {
                if (isSlideDown) {
                    $DivEntete.slideDown(300)
                } else {
                    $DivEntete.slideUp(300)
                }
            }
            opt.allowFullScreen = true
        }
        Me.dxContentEmailBase = $("<div style='width:100%;height:100%;'/>").appendTo($DivDoc).dxCtrlContentEmailBase(opt).dxCtrlContentEmailBase("instance")

        mReloadNbDestLAst24h()

    }

    this.mGetDxContentEmailBase = function () {
        return Me.dxContentEmailBase
    }

    var dxTagBoxDest = null
    function mRempliDest(funcEnd) {
        jauge.mShow();
        $DivDest.empty()
        //option.bddCtrl.mAjaxCall({command:"getcomdestdoc",})
        if (option.bddCtrl.getObjet(option.bddCtrl.utiCourant).objetMetier.mGetLstDataCompteEmail().length > 0) {
            var $Table = $("<table style='width:100%;'/>").appendTo($DivDest)
            var $Tr = $("<tr/>").appendTo($Table)
            var $TdDe = $("<td style='width:100%;'/>").appendTo($Tr)
            var dataCompteEmail = option.bddCtrl.getObjet(option.bddCtrl.utiCourant).objetMetier.mGetLstDataCompteEmail().filter(function (dataCpteEmail) {
                return dataCpteEmail.id_compte_email == option.data.id_compte_email
            })[0]
            if (typeof dataCompteEmail == 'undefined') {
                dataCompteEmail = option.bddCtrl.getObjet(option.bddCtrl.utiCourant).objetMetier.mGetDataCompteEmailDefaut()
                option.data.id_compte_email = dataCompteEmail.id_compte_email
                option.data.email_expediteur = dataCompteEmail.adresse_email
                option.bddCtrl.getObjet(option.data).mSave()
            }
            var dxCtrlEmailExp = $("<div style='margin20px;'/>").appendTo($TdDe).dxCtrlSelectBoxCompteEmail({
                bddCtrl: option.bddCtrl,
                //value: option.bddCtrl.getObjet(option.bddCtrl.utiCourant).objetMetier.mGetDataCompteEmailDefaut(),
                readOnly: (option.data.date_envoi != null),
                value: dataCompteEmail,
                onValueChanged: function (e) {
                    option.data.id_compte_email = e.value.id_compte_email
                    option.data.email_expediteur = e.value.adresse_email
                    var dataCompteEmail = option.bddCtrl.getObjet(option.bddCtrl.utiCourant).objetMetier.mGetLstDataCompteEmail().filter(function (dataCpteEmail) {
                        return dataCpteEmail.id_compte_email == option.data.id_compte_email
                    })[0]
                    option.data.nom_usuel_expediteur = option.bddCtrl.getObjet(dataCompteEmail).objetMetier.mGetNomUsuelCourant()
                    var dataCompteEmailUtilisateur = option.bddCtrl.getObjet(dataCompteEmail).objetMetier.mGetDataCompteEmailUtilisateur(option.bddCtrl.utiCourant.id_utilisateur)
                    //if (dataCompteEmailUtilisateur.nom_usuel != null && dataCompteEmailUtilisateur.nom_usuel.length > 0) {
                    //    option.data.nom_usuel_expediteur = dataCompteEmailUtilisateur.nom_usuel
                    //} else if (option.bddCtrl.utiCourant.nom_usuel != null && option.bddCtrl.utiCourant.nom_usuel.length > 0) {
                    //    option.data.nom_usuel_expediteur = option.bddCtrl.utiCourant.nom_usuel
                    //} else {
                    //    option.data.nom_usuel_expediteur = option.bddCtrl.getObjet(option.bddCtrl.utiCourant).objetMetier.mGetNomUsuel()
                    //}
                    option.bddCtrl.getObjet(option.data).mSave()
                    if (typeof option.onChangeExpediteur != 'undefined') option.onChangeExpediteur()
                    mReloadNbDestLAst24h()
                    if (dataCompteEmailUtilisateur.data_signature != 'undefined' && dataCompteEmailUtilisateur.data_signature != null) {
                        //on a une signature
                        //on propose de la charger
                        var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                            target: dxCtrlEmailExp.element(),
                            contentTemplate: function (contentElement) {
                                contentElement.css("padding", "30px")
                                $("<div>Cette adresse email dispose d'une signature.<br/>Voulez vous charger cette signature dans votre email ?</div>").appendTo(contentElement)
                                $("<div style='font-size:90%'><i>(l'ensemble du contenu de votre email sera remplacé par la signature)</i></div>").appendTo(contentElement)
                                $("<div style='margin-top:20px;'/>").appendTo(contentElement).dxCtrlButton({
                                    text: "Charger la signature",
                                    onClick: function (e) {
                                        tt.hide()
                                        option.bddCtrl.mAjaxCall({
                                            command: "gethtmlbodyfromsignature",
                                            data_signature: dataCompteEmailUtilisateur.data_signature
                                        }, function (data) {
                                            Me.dxContentEmailBase.mChangeHtml(data.html_body, "", function () {
                                                Me.dxContentEmailBase.isDirty(true)
                                                mNotify("La signature a été chargée", "success", 6000)
                                            })
                                        })
                                    }
                                })
                            }
                        }).dxCtrlTooltip("instance")
                        tt.show()
                    }
                }
            }).dxCtrlSelectBoxCompteEmail("instance")

            if (option.bddCtrl.objCptCli.data.multi_societe == "1") {
                $TdDe.css("width", "80%")
                var $TdSoc = $("<td style='width:20%;'/>").appendTo($Tr)
                $("<div/>").appendTo($TdSoc).dxSelectBox({
                    label: "Société",
                    labelMode: 'floating',
                    width: "100%",
                    dataSource: option.bddCtrl.mGetArray("societe").filter(function (o) { return o.date_abandon == null }),
                    value: option.data.id_societe,
                    displayExpr: "nom",
                    displayValue: "nom",
                    valueExpr: "id_societe",
                    onValueChanged: function (e) {
                        option.data.id_societe = e.value
                        option.bddCtrl.getObjet(option.data).mSaveChamp("id_societe")
                    }
                })
            }
            //if (option.bddCtrl.objCptCli.objetMetier.hasProjet() && !parametre.isMobile) {
            //    var $Td = $("<td style='width:30%;'/>").appendTo($Tr)
            //    $("<div style='padding:0 0px 0 10px;'/>").appendTo($Td).dxCtrlSelectProjet({
            //        bddCtrl: option.bddCtrl,
            //        data: option.data,
            //        onChanging: function (funcChange) {
            //            var obj = option.bddCtrl.getObjet(option.data)
            //            if (obj.cle() == null) {
            //                obj.mSave(function () { if (typeof funcChange != 'undefined') funcChange() })
            //            } else { if (typeof funcChange != 'undefined') funcChange() }
            //        }
            //    })
            //}
        }

        dxTagBoxDest = $("<div style='margin:2px;'/>").appendTo($DivDest).dxCtrlTagBoxDestinataireEmail({
            bddCtrl: option.bddCtrl,
            data: option.data,
            jauge: option.jauge,
            readOnly: (option.data.date_envoi != null),
            showCC: false,
            showCCI: false,
            funcSave: function (funcSaved) {
                Me.dxContentEmailBase.mSaveAuto(funcSaved, option.bddCtrl.getObjet(option.data).cle() == null)
                option.onRempliBt()
            },
            onChange: function () {
                option.onRempliBt()
            },
            //onDemandeGestion: function () {
            //    var obj = option.bddCtrl.getObjet(option.data)
            //    if (obj.cle() == null) {
            //        obj.mSave(function () { Me.mDisplayGestionAdresseEnvoi() })
            //    } else { Me.mDisplayGestionAdresseEnvoi() }
            //},
            onContentReady: function () {
                option.onRempliBt()
                if (typeof funcEnd != 'undefined') funcEnd()
            }
        }).dxCtrlTagBoxDestinataireEmail("instance")
    }

    //var nbDestLast24h = 0
    var dataDestLast24h = null
    function mReloadNbDestLAst24h() {
        var dataCompteEmail = option.bddCtrl.getObjet(option.bddCtrl.utiCourant).objetMetier.mGetLstDataCompteEmail().filter(function (dataCpteEmail) {
            return dataCpteEmail.id_compte_email == option.data.id_compte_email
        })[0]
        var idTypeSmtp = ((dataCompteEmail.envoi_actif == "0") ? 4 : 1)
        option.bddCtrl.mAjaxCall({
            command: "getdatadestinataire24h",
            id_type_smtp: idTypeSmtp,
            id_compte_email: option.data.id_compte_email
        }, function (data) {
            dataDestLast24h = data
            //nbDestLast24h = parseInt(data.nb)
        })
    }

    this.mSendEmail = function (target, verifObjet, verifTaille) {
        if (dxTagBoxDest.mGetNbDest_A_CC_CCI() == 0) {
            mNotify("Votre email doit comporter au moins un destinataire", "warning", 8000)
            dxTagBoxDest.dxTagBoxDestA.focus()
        } else if (verifTaille && option.data.taille_octet / 1024 / 1024 > 25) {
            var tttt = $("<div/>").appendTo("body").dxCtrlTooltip({
                target: target,
                contentTemplate: function (contentElement) {
                    var tailleMo = option.data.taille_octet / 1024 / 1024
                    contentElement.css("padding", "35px")
                    contentElement.css("white-space", "normal")
                    $("<div>Votre message fait une taille de <b>" + tailleMo.toFixed(2) + "Mo</b>.<br/><br/>En général, la limite de taille d'un message est de 25Mo.<br/>Si vous avez des pièces jointes volumineuses,<br/>nous vous conseillons de les<br/><a href='" + parametre.url_cognoss + "/0/6/La_box_de_fichier/bc' target='_blank'>héberger dans votre box dans les documents publics</a>.<br/><br/></div>").appendTo(contentElement)
                    $("<br/>").appendTo(contentElement)
                    $("<div/>").appendTo(contentElement).dxCtrlButton({
                        html: "Je ne suis pas concerné<br/>Envoyer quand même",
                        width: 250,
                        onClick: function (e) {
                            Me.mSendEmail(target, true, false)
                            tttt.hide()
                        }
                    })
                }
            }).dxCtrlTooltip("instance")
            tttt.show()
        } else if (verifObjet && (option.data.objet == null || option.data.objet.length == 0)) {
            var tttt = $("<div/>").appendTo("body").dxCtrlTooltip({
                target: target,
                contentTemplate: function (contentElement) {
                    contentElement.css("padding", "35px")
                    contentElement.css("white-space", "normal")
                    $("<div>Vous n'avez pas saisie d'objet.<br/>Voulez-vous tout de même envoyer votre email ?</div>").appendTo(contentElement)
                    $("<br/>").appendTo(contentElement)
                    $("<div/>").appendTo(contentElement).dxCtrlButton({
                        text: "Confirmez",
                        onClick: function (e) {
                            Me.mSendEmail(target, false, false)
                            tttt.hide()
                        }
                    })
                }
            }).dxCtrlTooltip("instance")
            tttt.show()
        } else {
            //on vérifie les destinataires 
            var nbDestCccCci = dxTagBoxDest.mGetNbDest_A_CC_CCI()
            if (nbDestCccCci <= parametre.nbre_destinataire_email_cc_cci_max) {
                var dataCompteEmail = option.bddCtrl.getObjet(option.bddCtrl.utiCourant).objetMetier.mGetLstDataCompteEmail().filter(function (dataCpteEmail) {
                    return dataCpteEmail.id_compte_email == option.data.id_compte_email
                })[0]
                var idTypeSmtp = ((dataCompteEmail.envoi_actif == "0") ? 4 : 1)
                //les destinataires sont cohérent
                if (option.data.tracking == "1" && nbDestCccCci > option.bddCtrl.objCptCli.objetMetier.mGetNbEmailDispo()) {
                    jauge.mHide()
                    option.bddCtrl.objCptCli.objetMetier.mSignaleLimiteAbonnement(target, "Vous ne disposez pas de suffisament de crédit EMAIL<br/>pour envoyer votre email<br/>en tracking.", "Acheter des crédits mails", 2, function () {
                        $("<div/>").appendTo("body").dxCtrlAchatPopup({
                            bddCtrl: option.bddCtrl,
                            typeProduit: "credit_email",
                            nb: nbDestCccCci,
                            onPaiement: function () {
                                jaugeDemarrage.mShow()
                                option.bddCtrl.mReloadTable("credit_email", function () { jaugeDemarrage.mHide() })
                            }
                        })
                    })
                } else {
                    if (idTypeSmtp == 4 && parseInt(dataDestLast24h.nb) + nbDestCccCci > 95) {
                        //sur quotidien et plus de 100 destinataires
                        var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                            target: target,
                            width: 400,
                            contentTemplate: function (contentElement) {
                                contentElement.css("padding", "25px")
                                contentElement.css("white-space", "normal")
                                $("<div style='font-weight:bold;'>Le SMTP de votre adresse email n'est pas actif.</div>").appendTo(contentElement)
                                $("<div style='font-weight:bold;'>Votre message sera envoyé via nos serveurs de messagerie.</div>").appendTo(contentElement)
                                $("<div style='margin-top:10px;'>Vous êtes limité à 100 messages par 24 heures glissantes</div>").appendTo(contentElement)
                                $("<div style='margin-top:10px;'>Avec votre envoi, vous allez dépasser cette limite (" + (parseInt(dataDestLast24h.nb) + lstComDestinataire.length) + ")</div>").appendTo(contentElement)
                                $("<div style='margin-top:10px;'>Vous pourrez à nouveau envoyer des mails à partir du " + dataDestLast24h.min_date_envoi.addDays(1).toFrenchDateTime() + "</div>").appendTo(contentElement)
                                $("<div style='margin:10px;'/>").appendTo(contentElement).dxCtrlButton({
                                    html: "Configurer le SMTP<br/>de l'adresse email",
                                    width: "100%",
                                    onClick: function (e) {
                                        option.bddCtrl.getObjet(dataCompteEmail).objetMetier.mShowPopup({
                                            id_utilisateur: option.bddCtrl.utiCourant.id_utilisateur,
                                            idAccordion: 2
                                        })
                                        tt.hide()
                                    }
                                })
                                $("<div style='margin:10px;'/>").appendTo(contentElement).dxCtrlButton({
                                    html: "Passer en mode mailing",
                                    width: "100%",
                                    onClick: function (e) {
                                        option.bddCtrl.getObjet(option.data).objetMetier.mPasseEnMailingFromPopup()
                                        //option.data.presentation_mailing = "1"
                                        //option.data.herberger_image = "1"
                                        //page.mRemovePopup(option.data, function () {
                                        //    option.bddCtrl.getObjet(option.data).mSave(function (data) {
                                        //        page.mAddPopup(option.data)
                                        //        mNotify("Votre message est maintenant classé dans les brouillons de l'onglet emailing","success",15000)
                                        //    })
                                        //})
                                        tt.hide()
                                    }
                                })
                            }
                        }).dxCtrlTooltip("instance")
                        tt.show()
                    } else if (idTypeSmtp == 1 && parseInt(dataDestLast24h.nb) + nbDestCccCci > dataCompteEmail.envoi_nb_email_smtp_jour) {
                        //sur smtpemail et plus de 500 destinataires
                        var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                            target: target,
                            width: 400,
                            contentTemplate: function (contentElement) {
                                contentElement.css("padding", "25px")
                                contentElement.css("white-space", "normal")
                                $("<div style='font-weight:bold;'>Vous envoyez vos emails via le SMTP de votre adresse email.</div>").appendTo(contentElement)
                                $("<div style='font-weight:bold;'>La plupart des SMTP limite le nombre de message envoyé par jour à " + dataCompteEmail.envoi_nb_email_smtp_jour + " par 24 heures glissantes.</div>").appendTo(contentElement)
                                $("<div style='margin-top:10px;'>Avec votre envoi, vous allez dépasser cette limite (" + (parseInt(dataDestLast24h.nb) + nbDestCccCci) + ")</div>").appendTo(contentElement)
                                $("<div style='margin-top:10px;'>Vous pourrez à nouveau envoyer des mails à partir du " + dataDestLast24h.min_date_envoi.addDays(1).toFrenchDateTime() + "</div>").appendTo(contentElement)
                                $("<div style='margin-top:10px;'>(Vous pouvez modifier le paramétrage du nombre d'envoi journalier via <a class='link' style='cursor:pointer;'>votre configuration SMTP</a>)</div>").appendTo(contentElement)
                                contentElement.find(".link").on("click", function () {
                                    option.bddCtrl.getObjet(dataCompteEmail).objetMetier.mShowPopup({
                                        id_utilisateur: option.bddCtrl.utiCourant.id_utilisateur,
                                        idAccordion: 2
                                    })
                                    tt.hide()
                                })
                                $("<div style='margin:10px;'/>").appendTo(contentElement).dxCtrlButton({
                                    html: "Envoyer quand même",
                                    width: "100%",
                                    hint: "Si vous ne pensez pas être concerné par cette limite, vous pouvez envoyer votre email via le smtp de votre adresse email",
                                    onClick: function (e) {
                                        Me.mSend()
                                        page.mRemovePopup(option.data)
                                        //option.bddCtrl.getObjet(dataCompteEmail).objetMetier.mShowPopup({
                                        //    id_utilisateur: option.bddCtrl.utiCourant.id_utilisateur,
                                        //    idAccordion: 2
                                        //})
                                        tt.hide()
                                    }
                                })
                                $("<div style='margin:10px;'/>").appendTo(contentElement).dxCtrlButton({
                                    html: "Passer en mode mailing",
                                    hint: "Par précaution, vous pouvez passer en mode mailing pour cette envoi<br/>(et utiliser ainsi les serveurs de messagerie de " + parametre.nom + ")",
                                    width: "100%",
                                    onClick: function (e) {
                                        option.data.presentation_mailing = "1"
                                        option.data.herberger_image = "1"
                                        page.mRemovePopup(option.data, function () {
                                            option.bddCtrl.getObjet(option.data).mSave(function (data) {
                                                page.mAddPopup(option.data)
                                            })
                                        })
                                        tt.hide()
                                    }
                                })
                            }
                        }).dxCtrlTooltip("instance")
                        tt.show()
                    } else if (idTypeSmtp == 4) {
                        //sur quotidien ok
                        if (typeof option.bddCtrl.utiCourantParaJson.warning.email["idcompte_email_" + dataCompteEmail.id_compte_email] == 'undefined') option.bddCtrl.utiCourantParaJson.warning.email["idcompte_email_" + dataCompteEmail.id_compte_email] = {}
                        if (option.bddCtrl.utiCourantParaJson.warning.email["idcompte_email_" + dataCompteEmail.id_compte_email].date_prevenir_smtp_off == null ||
                            (option.bddCtrl.utiCourantParaJson.warning.email["idcompte_email_" + dataCompteEmail.id_compte_email].date_prevenir_smtp_off != null &&
                                option.bddCtrl.utiCourantParaJson.warning.email["idcompte_email_" + dataCompteEmail.id_compte_email].date_prevenir_smtp_off < parametre.dateNow)) {
                            jauge.mHide()
                            var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                                target: target,
                                width: 400,
                                contentTemplate: function (contentElement) {
                                    contentElement.css("padding", "25px")
                                    contentElement.css("white-space", "normal")
                                    $("<div style='font-weight:bold;'>Le SMTP de votre adresse email n'est pas actif.</div>").appendTo(contentElement)
                                    $("<div style='font-weight:bold;'>Votre message sera envoyé via nos serveurs de messagerie.</div>").appendTo(contentElement)
                                    $("<div style='margin-top:10px;'>Pour une meilleure délivrabilité, nous vous conseillons d'utiliser le SMTP de votre adresse email</div>").appendTo(contentElement)
                                    $("<div style='margin:10px;'/>").appendTo(contentElement).dxCtrlButton({
                                        html: "Configurer le SMTP<br/>de l'adresse email",
                                        width: "100%",
                                        onClick: function (e) {
                                            option.bddCtrl.getObjet(dataCompteEmail).objetMetier.mShowPopup({
                                                id_utilisateur: option.bddCtrl.utiCourant.id_utilisateur,
                                                idAccordion: 2
                                            })
                                            tt.hide()
                                        }
                                    })
                                    $("<div style='margin:10px;'/>").appendTo(contentElement).dxCtrlButton({
                                        html: "J'ai compris, envoyer via<br/>les serveurs de " + parametre.nom,
                                        width: "100%",
                                        onClick: function (e) {
                                            Me.mSend()
                                            page.mRemovePopup(option.data)
                                            tt.hide()
                                        }
                                    })
                                    $("<div style='margin:0 10px;'/>").appendTo(contentElement).dxCheckBox({
                                        text: "Ne plus me prévenir de cela pendant 1 mois",
                                        value: false,
                                        onValueChanged: function (e) {
                                            if (typeof option.bddCtrl.utiCourantParaJson.warning.email["idcompte_email_" + dataCompteEmail.id_compte_email] == 'undefined') option.bddCtrl.utiCourantParaJson.warning.email["idcompte_email_" + dataCompteEmail.id_compte_email] = {}
                                            if (e.value) {
                                                option.bddCtrl.utiCourantParaJson.warning.email["idcompte_email_" + dataCompteEmail.id_compte_email].date_prevenir_smtp_off = (new Date(parametre.dateNow)).addMonths(1)
                                            } else {
                                                option.bddCtrl.utiCourantParaJson.warning.email["idcompte_email_" + dataCompteEmail.id_compte_email].date_prevenir_smtp_off = null
                                            }
                                            option.bddCtrl.mSaveParaJsonUtilisateur();
                                        }
                                    })
                                }
                            }).dxCtrlTooltip("instance")
                            tt.show()
                        } else {
                            Me.mSend()
                            page.mRemovePopup(option.data)
                        }
                    } else {
                        //sur smtpemail ok
                        Me.mSend()
                        page.mRemovePopup(option.data)
                    }
                }
            } else {
                //on dépasse, on affiche la gestion
                //on propose de passer en mailing
                var tttt = $("<div/>").appendTo("body").dxCtrlTooltip({
                    target: target,
                    contentTemplate: function (contentElement) {
                        contentElement.css("padding", "35px")
                        contentElement.css("white-space", "normal")
                        $("<div>Vous avez plus de " + parametre.nbre_destinataire_email_cc_cci_max + " destinataires pour votre emails.<br/>Vous devez passer en mode mailing pour envoyer votre email.<br/>Voulez vous le faire immédiatement ?</div>").appendTo(contentElement)
                        $("<br/>").appendTo(contentElement)
                        $("<div/>").appendTo(contentElement).dxCtrlButton({
                            text: "Confirmez",
                            onClick: function (e) {
                                option.bddCtrl.getObjet(option.data).objetMetier.mPasseEnMailingFromPopup()
                                //option.data.presentation_mailing = "1"
                                //option.data.herberger_image = "1"
                                //page.mRemovePopup(option.data, function () {
                                //    option.bddCtrl.getObjet(option.data).mSave(function (data) {
                                //        page.mAddPopup(option.data)
                                //    })
                                //})
                                tttt.hide()
                            }
                        })
                    }
                }).dxCtrlTooltip("instance")
                tttt.show()
            }
        }
    }

    this.mSend = function () {
        Me.dxContentEmailBase.mStopSaveAuto(function () {
            page.mRemovePopup(option.data)
            option.bddCtrl.mAjaxCall({
                command: "getlstdestcomforgestion",
                id_table_com: option.bddCtrl.getObjet(option.data).mGetTable().id_table,
                id_com: option.data.id_com_email_envoi,
                type: "email"
            }, function (data) {
                if (typeof data.lst_com_destinataire == 'undefined') data.lst_com_destinataire = []
                var lstComDestinataire = data.lst_com_destinataire
                var clComDest = new cComDest(option.bddCtrl, lstComDestinataire)
                //moins de 100 destinataires, nettoyage auto et on garde les listes noires 
                if (clComDest.mGetLstDestCom().length != clComDest.mGetLstDestComNettoyerAvecBounce().length) {
                    clComDest.mNettoieIDentiqueEtDoublonETSansAdresseAndSave(function () {
                        if (clComDest.mGetLstDestCom().length == 0) {
                            page.mAddPopup(option.data)
                            window.setTimeout(function () {
                                mNotify("Pas de destinataire sur votre email", "warning", 6000)
                            }, 500)
                        } else {
                            option.bddCtrl.getObjet(option.data).objetMetier.mSend()
                            mAfficheMessageSiHoraireEnvoiCompteEmail()
                        }
                    })
                    return
                } if (clComDest.mGetLstDestCom().length == 0) {
                    page.mAddPopup(option.data)
                    window.setTimeout(function () {
                        mNotify("Pas de destinataire sur votre email", "warning", 6000)
                    }, 500)
                } else {
                    option.bddCtrl.getObjet(option.data).objetMetier.mSend()
                    mAfficheMessageSiHoraireEnvoiCompteEmail()
                }
            })
        })
    }

    function mAfficheMessageSiHoraireEnvoiCompteEmail() {
        if (option.bddCtrl.getObjet("compte_email", option.data.id_compte_email).data.envoi_has_horaire == "1") {
            //on a des horaires d'envoi pour ce compte email
            //on vérifie si on est dans ces horaires
            //Si ce n'est pas le cas on informe
            option.bddCtrl.mAjaxCall({ command: "isemailenvoienattente", id_com_email_envoi: option.data.id_com_email_envoi }, function (data) {
                if (data.is_en_attente == "1") {
                    notify.mShow({
                        showTitle: false,
                        width: 340,
                        message: function (contentElement, popup) {
                            contentElement.css("font-size", "100%")
                            contentElement.css("padding-left", "10px")
                            var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
                            var $Tr = $("<tr/>").appendTo($Table)
                            var $TdMessage = $("<td style='text-align:left;'>Votre email a été mis en attente, conformément à la configuration de votre compte email où sont définies des horaires d'envois.</td>").appendTo($Tr)
                            var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
                            $("<div/>").appendTo($Td).dxCtrlButton({
                                icon: "fas fa-arrow-turn-down fa-rotate-180",
                                txtTooltip: "Annuler l'envoi<br/>et remettre le message dans les brouillons",
                                width: "100%",
                                onClick: function (e) {
                                    option.data.date_envoi = null
                                    option.data.id_type_classement = 7
                                    option.bddCtrl.getObjet(option.data).mSave()
                                    window.setTimeout(function () { page.mAddPopup(option.data) }, 500)
                                    popup.hide()
                                    mNotify("Votre email a été replace dans les brouillons", "warning", 1000)
                                }
                            })
                            var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                            $("<div/>").appendTo($Td).dxCtrlButton({
                                icon: "fas fa-paper-plane",
                                txtTooltip: "Envoyer votre email immédiatement",
                                icon2: "fas fa-arrow-right",
                                width: "100%",
                                onClick: function (e) {
                                    option.data.ignore_attente_compte_email = "1"
                                    option.data.id_type_classement = 9
                                    option.bddCtrl.getObjet(option.data).mSave()
                                    popup.hide()
                                    mNotify("Votre email va être envoyé immédiatement", "success", 1000)
                                }
                            })
                        },
                        tempoSeconde: 8
                    })
                } else {
                    mAfficheMessageSiTempoEnvoi()
                }
            })
        } else { mAfficheMessageSiTempoEnvoi() }
    }
    function mAfficheMessageSiTempoEnvoi() {
        var dataCompteEmail = option.bddCtrl.mGetArray("compte_email").filter(function (o) { return o.id_compte_email == option.data.id_compte_email })[0]
        if (dataCompteEmail.envoi_temporisation_mn != null || (new Date(option.data.date_envoi)).addMinutes(-5) > parametre.dateNow) {
            notify.mShow({
                showTitle: false,
                width: 340,
                message: function (contentElement, popup) {
                    contentElement.css("font-size", "100%")
                    contentElement.css("padding-left", "10px")
                    mConstruitContainerEnvoiTempo(contentElement, false, function () { popup.hide() })
                    //var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
                    //var $Tr = $("<tr/>").appendTo($Table)
                    //var $TdMessage = $("<td style='white-space:nowrap;padding-right:5px;text-align:right;'/>").appendTo($Tr)
                    //var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
                    //$("<div/>").appendTo($Td).dxCtrlButton({
                    //    icon: "fas fa-xmark",
                    //    txtTooltip: "Annuler l'envoi<br/>et remettre le message dans les brouillons",
                    //    width: "100%",
                    //    onClick: function (e) {
                    //        option.data.date_envoi = null
                    //        option.data.id_type_classement = 7
                    //        option.bddCtrl.getObjet(option.data).mSave()
                    //        popup.hide()
                    //        mNotify("Votre email a été replace dans les brouillons", "warning", 1000)
                    //    }
                    //})
                    //var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                    //$("<div/>").appendTo($Td).dxCtrlButton({
                    //    icon: "fas fa-paper-plane",
                    //    txtTooltip: "Envoyer votre email immédiatement",
                    //    icon2: "fas fa-arrow-right",
                    //    width: "100%",
                    //    onClick: function (e) {
                    //        option.data.date_envoi = new Date(parametre.dateNow.getTime())
                    //        option.bddCtrl.getObjet(option.data).mSaveChamp("date_envoi")
                    //        popup.hide()
                    //        mNotify("Votre email va être envoyé immédiatement", "success", 1000)
                    //    }
                    //})
                    //function mDecompte() {
                    //    if ($TdMessage.closest("body").length == 0 || objet.data.date_envoi == null) return
                    //    $TdMessage.html("L'email sera envoyé dans<br/>" + (new Date()).decompte(objet.data.date_envoi))
                    //    if (diffdate(parametre.dateNow, objet.data.date_envoi, "s") < 3) {
                    //        popup.hide()
                    //    } else { window.setTimeout(function () { mDecompte() }, 1000) }
                    //}
                    //mDecompte()
                },
                tempoSeconde: 10
            })
        }
    }

    function mConstruitContainerEnvoiTempo(contentElement, detail, funcDepasse) {
        var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $TdMessage = $("<td style='white-space:nowrap;padding-right:5px;text-align:right;'/>").appendTo($Tr)
        var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-xmark",
            text: ((detail) ? "Annuler" : ""),
            txtTooltip: "Annuler l'envoi<br/>et remettre le message dans les brouillons",
            width: "100%",
            onClick: function (e) {
                option.data.date_envoi = null
                option.data.id_type_classement = 7
                option.bddCtrl.getObjet(option.data).mSave(function (data) {
                    option.bddCtrl.getObjet(option.data).mShowPopup()
                })
                funcDepasse()
                window.setTimeout(function () { page.mAddPopup(option.data) }, 1000)
                mNotify("Votre email a été replace dans les brouillons", "warning", 1000)
            }
        })
        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-paper-plane",
            text: ((detail) ? "Envoyer immédiatement" : ""),
            txtTooltip: "Envoyer votre email immédiatement",
            icon2: "fas fa-arrow-right",
            width: "100%",
            onClick: function (e) {
                option.data.date_envoi = new Date(parametre.dateNow.getTime())
                option.bddCtrl.getObjet(option.data).mSaveChamp("date_envoi")
                funcDepasse()
                mNotify("Votre email va être envoyé immédiatement", "success", 1000)
            }
        })
        function mDecompte() {
            if ($TdMessage.closest("body").length == 0 || option.data.date_envoi == null) return
            let totalSeconds = 500;
            let minutes = Math.floor(totalSeconds / 60);
            let seconds = totalSeconds % 60;
            var dataCompteEmail = option.bddCtrl.mGetArray("compte_email").filter(function (o) { return o.id_compte_email == option.data.id_compte_email })[0]
            if (dataCompteEmail.envoi_temporisation_mn != null && option.data.ignore_attente_compte_email == "0") {
                $TdMessage.html("L'envoi de vos emails est temporisé.<br/>L'email sera envoyé dans " + (new Date()).decompte(option.data.date_envoi))
            } else if ((new Date(option.data.date_envoi)).addMinutes(-5) > parametre.dateNow && option.data.ignore_attente_compte_email == "1") {
                $TdMessage.html("Une date d'envoi dans le futur a été programmée.<br/>L'email sera envoyée dans " + (new Date()).decompte(option.data.date_envoi) + " (" + option.data.date_envoi.toFrenchDateTime() + ").")
            } else {
                $TdMessage.html("L'envoi de vos emails est temporisé.<br/>L'email sera envoyé dans " + (new Date()).decompte(option.data.date_envoi))
            }
            if (diffdate(parametre.dateNow, option.data.date_envoi, "s") < 3) {
                funcDepasse()
            } else { window.setTimeout(function () { mDecompte() }, 1000) }
        }
        mDecompte()
    }


    function mFinLoad() {
        if (dxTagBoxDest.isLoaded && Me.dxContentEmailBase.isInit) {
            jauge.mHide();
            window.setTimeout(function () { mSelectOnFinLoad(); }, 300)
        }
        else { window.setTimeout(function () { mFinLoad(); }, 30) }
    }

    function mSelectOnFinLoad() {
        if (dxTagBoxDest.mGetNbDest_A_CC_CCI() == 0) { dxTagBoxDest.dxTagBoxDestA.focus() }
        else { Me.dxContentEmailBase.focus() }
    }

    this.mGetNbDestACCCCI = function () {
        return dxTagBoxDest.mGetNbDest_A_CC_CCI()
    }

    this.element = function () { return container }

    //this.dispose = function () {
    //    if (Me.dxContentEmailBase) Me.dxContentEmailBase.dispose()
    //    if (dxTagBoxDest) dxTagBoxDest.dispose()
    //}

    mConstruit();
}